/* eslint-disable max-classes-per-file */
import Vue from 'vue';
import _ from '../../utils';
import { ApiMethod } from './apiMethod';

export type ResponseType = 'formdata' | 'text' | 'json' | 'blob' | 'arraybuffer';

export default class RequestConfig {
  url?: string;
  type?: ApiMethod;
  baseURL?: string;
  headers?: Record<string, string>;
  query?: Record<string, string[] | number[] | boolean[] | string | number | boolean | undefined | null>;
  body?: any;
  skipInterceptors?: boolean;
  writeValuesToConsole?: boolean;
  withCredentials?: boolean;
  auth?: { password: string, username: string };
  responseType?: ResponseType;
  signal?: AbortSignal;
}

class RequestConfigConverter {
  getFullUrl(url: string, requestConfig?: RequestConfig) {
    let urlQueryString = '';
    if (requestConfig?.query) {
      urlQueryString = url.includes('?') ? '' : '?';
      const params: string[] = [];
      Object.entries(requestConfig.query).forEach(([key, value]) => {
        key = encodeURIComponent(key);
        if (value !== undefined) {
          if (_.isArray(value)) {
            value.forEach((i) => {
              params.push(`${key}=${encodeURIComponent(i.toString())}`);
            });
          } else if (value === null) {
            params.push(`${key}=null`);
          } else {
            params.push(`${key}=${encodeURIComponent(value.toString())}`);
          }
        }
      });
      urlQueryString += params.join('&');
    }

    if (url.match(/'^https?:\/\/'/)) {
      return url + urlQueryString;
    }

    const baseUrl = requestConfig?.baseURL ?? Vue.$fetch.defaults.baseUrl;
    return baseUrl + url + urlQueryString;
  }
  toFetch(method: ApiMethod, fullUrl: string, requestConfig: RequestConfig) {
    const { body } = requestConfig;
    const isJson = typeof body !== 'string'
      && !(body instanceof Blob)
      && !(body instanceof ArrayBuffer) // ArrayBufferView is ignored
      && !(body instanceof FormData)
      && !(body instanceof ReadableStream)
      && !(body instanceof URLSearchParams);
    const isSameSite = new URL(fullUrl, window.location.origin).host === window.location.host;
    const fetchConfig: RequestInit = {
      body: isJson ? JSON.stringify(requestConfig.body) : requestConfig.body,
      headers: {
        Accept: 'application/json, text/plain, */*',
        ...(isJson ? { 'Content-Type': 'application/json' } : {}),
        ...Vue.$fetch.defaults.headers,
        ...requestConfig.headers,
      },
      method,
      signal: requestConfig.signal,
      mode: isSameSite ? 'same-origin' : 'cors',
      credentials: requestConfig.withCredentials ? 'include' : 'omit',
    };
    return fetchConfig;
  }
}
const requestConfigConverter = new RequestConfigConverter();
export { requestConfigConverter };
